export const isAuthenticated = () => {
    let acesso = localStorage.getItem('acesso')

    switch (acesso){
        case 'admin' : return 'admin'; break
        case 'normal': return 'normal'; break
        default : return null; break
    }
   
};